import { render } from "./tSidebar.vue?vue&type=template&id=af869774&scoped=true"
import script from "./tSidebar.vue?vue&type=script&lang=js"
export * from "./tSidebar.vue?vue&type=script&lang=js"

import "./tSidebar.vue?vue&type=style&index=0&id=af869774&lang=less&scoped=true"

import exportComponent from "D:\\huiwu\\wgt_user_web_3.0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af869774"]])

export default __exports__